import React, { FC } from 'react';
import { Popover } from 'antd';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { IPrompt } from './interfaces';

const Prompt: FC<IPrompt> = ({ children, style, className, overlayStyle }) => {
  return (
    <Popover
      content={children}
      className={className}
      // @ts-ignore
      zIndex="2000"
      overlayStyle={overlayStyle}
    >
      <QuestionCircleOutlined
        translate=""
        size={32}
        style={style}
        color="#878787"
      />
    </Popover>
  );
};

export default Prompt;
